/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  ButtonGroup,
  CircularProgress,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import AddModal from "../../components/modal/AddModal";
import ViewModal from "../../components/modal/ViewModal";
import TableFilter from "../../components/table-components/filter/TableFilter";
import Pagination from "../../components/table-components/pagination/Pagination";
import TableComp from "../../components/table-components/table/TableComp";
import useGetVolunteersByTrialId from "../../hooks/useGetVolunteersByTrialId";
import {
  handleHistoryOpenModal,
  handleViewOpen,
  rowValue,
} from "../../redux/Reducer/ModalSlice";
import TrialAdd from "./TrialAdd";
import TrialVolunteerProfile from "./TrialVolunteerProfile";

const TrialTablePage = ({ user, trialCode }) => {
  const dispatch = useDispatch();

  //! api call
  const {
    getVolunteersByTrialId,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
  } = useGetVolunteersByTrialId(trialCode);

  // function handleEdit(rowData) {
  //   dispatch(handleEditOpen());
  //   dispatch(rowValue(rowData));
  // }
  function handleView(rowData) {
    dispatch(handleViewOpen());
    dispatch(rowValue(rowData));
  }
  // function handleHistory(rowData) {
  //   dispatch(handleHistoryOpenModal());
  //   dispatch(rowValue(rowData));
  // }

  // const handleStatusSubmit = (rowData) => {
  //   const approved_status = { activeStatus: "1" };

  //   fetch(
  //     `${process.env.REACT_APP_API_URL}/api/updateVoluntary/${rowData.vol_no}`,
  //     {
  //       method: "PUT",
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //       body: JSON.stringify(approved_status),
  //     }
  //   ).then((res) => {
  //     return res.json();
  //   });
  // };

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "SL No.",
      //   accessor: "index",
      //   Cell: (row) => {
      //     return <div>{Number(row.row.id) + 1}</div>;
      //   },
      //   Filter: false,
      // },
      {
        Header: "Study Name",
        accessor: "study_name",
        Filter: false,
      },
      {
        Header: "Trial Name",
        accessor: "trial_name",
        Filter: false,
      },
      {
        Header: "Volunteer Name",
        accessor: "full_name",
        Filter: false,
      },
      {
        Header: () => <div style={{ marginLeft: "20px" }}>Action</div>,
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* {(user === "Admin" || user === "Developer") && (
              <IconButton
                size="small"
                sx={{ "&:hover": { color: "#2e68e8" } }}
                style={{ color: "#2196F3" }}
                variant="none"
                onClick={() => handleEdit(row.row.original)}
              >
                <Tooltip title="Update">
                  <EditIcon
                    // fontSize="small"
                    sx={{ fontSize: 18 }}
                  />
                </Tooltip>
              </IconButton>
            )} */}
            {/* <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon
                  // fontSize="small"
                  sx={{ fontSize: 18 }}
                />
              </Tooltip>
            </IconButton> */}
            {/* <MouseDiv> */}
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#189A2E" }}
              variant="none"
              onClick={() => handleView(row.row.original)}
            >
              <Tooltip title="Details">
                <VisibilityIcon
                  sx={{ fontSize: 18 }}
                // fontSize="small"
                />
              </Tooltip>
            </IconButton>

            {/* history button */}
            {/* <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#1976D2" }}
              variant="none"
              onClick={() => handleHistory(row.row.original)}
            >
              <Tooltip title="Add History">
                <HistoryEduIcon
                  sx={{ fontSize: 18 }}
                  // fontSize="small"
                />
              </Tooltip>
            </IconButton> */}
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const add = useSelector((state) => state.Modal.add);
  // const edit = useSelector((state) => state.Modal.edit);
  // const view = useSelector((state) => state.Modal.edit);

  // console.log("add", add);
  // console.log("edit", edit);
  useEffect(() => {
    if (!add) {
      refetch();
    }
  }, [add, refetch]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: getVolunteersByTrialId.vol_info || [] },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex } = state;
  return (
    <>
      {/* <div>
        <VolunteerFilter filter={globalFilter} setFilter={setGlobalFilter} />
      </div> */}
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add Volunteer into Trial"
        />
      </div>

      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading ? (
          <div
            style={
              {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "280px",
              }
              // display:"flex",
            }
          >
            <CircularProgress />
          </div>
        ) : (
          page.length === 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "280px",
              }}
            >
              <Typography variant="body1" color="text.secondary">
                No data available
              </Typography>
            </div>
          )
        )}

        {/* no data available */}
        { }

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>

      <AddModal ModalWidth="xl" ModalTitle="Add volunteer into trial">
        <TrialAdd trialCode={trialCode} />
      </AddModal>
      {/* <EditModal ModalWidth="md" ModalTitle="Edit Volunteer Information">
        <VolunteerEdit />
      </EditModal> */}
      <ViewModal ModalWidth="md" ModalTitle="Volunteer Profile">
        <TrialVolunteerProfile />
      </ViewModal>
      {/* <HistoryModal ModalWidth="md" ModalTitle="Volunteer History">
        <TrialHistoryTableAdd />
      </HistoryModal> */}
    </>
  );
};

export default TrialTablePage;
